import { useState, useEffect } from "react";
import { createUseStyles } from "react-jss";

import { rarityService } from "services";
import { RarityCommon, RarityDto, RarityRequestDto } from "dtos/shard/rarity.dto";
import { UserDto } from "dtos/user.dto";

import widgets from "styles/widgets";
import { useResources } from "hooks/resources.hook";
import { useEditorActions } from "hooks/editor-actions.hook";
import { useEditorPreview } from "hooks/editor-preview.hook";
import EditorControls from "../editor-controls";

const styles = createUseStyles({
    container: {
        width: "100%",
    },
});

export default function RarityEditor(props: {
    user?: UserDto, // Optional dto of the user.
    rarity?: Partial<RarityDto>,
    preview?: Partial<RarityDto>,
    onPreviewUpdate?: (previewDto: Partial<RarityDto>) => void,
    onClose?: () => void,
    onSave?:(rarity: RarityDto) => void,
}): JSX.Element
{
    // Dtos:
    const freshCommon: RarityCommon = {
        name: props.rarity?.name ?? "",
    };
    const freshRequestDto: RarityRequestDto = {
        id: props.rarity?.id,
        ...freshCommon,
    };
    const freshPreviewDto: Partial<RarityDto> = props.preview ? structuredClone(props.preview) : props.rarity ? structuredClone(props.rarity) : {
        id: undefined,
        ...freshCommon,
    };

    // Hooks:
    const resources = useResources(props.user);
    const [previewDto, requestDto, previewUpdate, setRequestDto] = useEditorPreview(freshPreviewDto, freshRequestDto, props.onPreviewUpdate);
    const [onTextChange, onNumberChange, onRteChange, onCheckboxChange, onPopup] = useEditorActions(props.user, "rarity", resources, requestDto, previewDto, setRequestDto, props.onPreviewUpdate);

    // Effects:
    useEffect(() => {
        setRequestDto(freshRequestDto);
    }, [props.rarity]);

    // Styles:
    const widgetClasses = widgets();
    const classes = styles();

    // Raritys:
    const reset = () => {
        setRequestDto(freshRequestDto);
        if (props.onPreviewUpdate) {
            props.onPreviewUpdate(props.rarity ?? previewDto);
        }
    };
    
    // Return Component:
    return (
        <div className={`${widgetClasses.form} ${classes.container}`}>
            <div className={`${widgetClasses.row}`}>
                <label>Name</label>
                <input id="name" type="text" value={requestDto.name ?? ""} onChange={onTextChange} />
            </div>

            <hr/>
            <EditorControls
                editorName="rarity"
                service={rarityService}
                subject={props.rarity}
                subjectName={props.rarity?.name ?? ""}
                requestDto={requestDto}
                onSave={props.onSave}
                onReset={reset}
                onClose={props.onClose}
            />
            <hr/>
        </div>
    );
}